import { Route } from '@angular/router';

import { LayoutComponent } from '@app/layout/layout.component';
import { SociuuhubComponent } from './modules/sociuuhub/sociuuhub.component';

import { AuthGuard } from '@guards/auth.guard';
import { SociuuhubGuard } from './core/guards/sociuuhub.guard';
import { ClientInfoGuard } from './core/guards/client-info.guard';

import { InitialDataResolver } from '@resolvers/app.resolvers';
import { UserProfileResolver } from './resolvers/user-profile.resolver';
import { CountSettingsResolver } from '@resolvers/count-settings.resolver';

const DEFAULT_ROUTE_DATA = {
  isAdmin: false,
  isSociuuhub: false,
  isHubspotEnabled: false,
};

const SOCIUUHUB_ROUTE_DATA = {
  ...DEFAULT_ROUTE_DATA,
  isSociuuhub: true,
};

const ADMIN_ROUTE_DATA = {
  ...DEFAULT_ROUTE_DATA,
  isAdmin: true,
  isHubspotEnabled: true,
};

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [ClientInfoGuard],
    children: [
      // Public routes
      {
        path: 'public',
        data: DEFAULT_ROUTE_DATA,
        loadChildren: () => import('app/modules/public/public.module').then((m) => m.PublicModule),
      },
      // Error routes
      {
        path: 'error',
        loadChildren: () => import('app/modules/error/error.module').then((m) => m.ErrorModule),
      },
      // Preview routes
      {
        path: 'preview',
        data: DEFAULT_ROUTE_DATA,
        loadChildren: () => import('app/modules/admin/post-preview/post-preview.module').then((m) => m.PostPreviewModule),
      },

      // Sociuuhub routes
      {
        path: 'sociuuhub',
        data: SOCIUUHUB_ROUTE_DATA,
        component: SociuuhubComponent,
        canActivate: [SociuuhubGuard],
        loadChildren: () => import('app/modules/sociuuhub/sociuuhub.module').then((m) => m.SociuuhubModule),
      },

      // Admin routes
      {
        path: '',
        component: LayoutComponent,
        resolve: {
          initialData: InitialDataResolver,
          userProfile: UserProfileResolver,
          countSettings: CountSettingsResolver,
        },
        canActivate: [AuthGuard],
        data: ADMIN_ROUTE_DATA,
        loadChildren: () => import('app/modules/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'login',
        loadChildren: () => import('app/modules/admin/auth/auth.module').then((m) => m.AuthModule),
        data: DEFAULT_ROUTE_DATA,
      },
      {
        path: 'reset/:token',
        loadChildren: () => import('app/modules/admin/activation-reset/activation-reset.module').then((m) => m.ActivationResetModule),
        data: DEFAULT_ROUTE_DATA,
      },
      {
        path: 'activation/:token',
        loadChildren: () => import('app/modules/admin/activation-reset/activation-reset.module').then((m) => m.ActivationResetModule),
        data: DEFAULT_ROUTE_DATA,
      },
      { path: 'signup', redirectTo: 'sociuuhub/signup' },
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      { path: 'close', pathMatch: 'full', redirectTo: 'public/close' },
      { path: '**', redirectTo: 'dashboard' },
    ],
  },
];
